<template>
    <div class="codics-aonaer-info-sys-user-shop-body">
        <div class="codics-aonaer-info-sys-user-shop-left-tab">
            <div class="codics-aonaer-info-sys-user-shop-left-tab-item" v-for="(item, index) in tabData" :key="index"
                :style="{ 'background': index == nowIndex ? '#FFF' : '#f3f3f3' }"
                @click="nowIndex = index; getProductListData(item.value);" v-html="item.label">
            </div>
        </div>
        <div class="codics-aonaer-info-sys-user-shop-right-box">
            <el-image v-show="productData.length == 0 && !productLoad"
                @click="getProductListData(tabData[nowIndex].value)"
                class="codics-aonaer-info-sys-user-shop-right-box-empty"
                src="https://cdn.bosscaigou.com/huayuan/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9%20%281%29.svg"
                fit="fill"></el-image>
            <div class="codics-aonaer-info-sys-user-shop-right-box-load" v-show="productLoad"></div>
            <div class="codics-aonaer-info-sys-user-shop-right-box-product-item" v-for="(item, index) in productData"
                :key="index">
                <div class="codics-aonaer-info-sys-user-shop-right-box-product-item-card">
                    <el-image class="codics-aonaer-info-sys-user-shop-right-box-product-item-card-img"
                        :src="initHimg(item.img)"></el-image>
                    <div class="codics-aonaer-info-sys-user-shop-right-box-product-item-title" v-html="item.name"></div>
                    <div class="codics-aonaer-info-sys-user-shop-right-box-product-item-line iconfont">
                        &#xe62d; {{ item.price }} <span style="color: #BBB;font-size: 10px;">已兑换{{ item.sell }}件</span>
                        <div class="codics-aonaer-info-sys-user-shop-right-box-product-item-exchange iconfont"
                            @click="exchangeProductFuc(item.id)">兑换</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getProductList, exchangeProduct } from '@/api';
export default {
    data() {
        return {
            productLoad: true,
            nowIndex: 0,
            tabData: [],
            productData: []
        }
    },
    mounted() {
        this.getProductListData(0);
    },
    methods: {
        initHimg(str) {

            return 'https://cdn.bosscaigou.com/' + str.split(',')[0];

        },
        async exchangeProductFuc(id) {

            this.$confirm('您确定要兑换当前商品吗？')
                .then(async _ => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    let data = await exchangeProduct({ pid: id });

                    loading.close();

                    if (data.code == 200) {

                        this.$message({
                            message: '兑换商品成功！',
                            type: 'success'
                        });

                        setTimeout(() => {

                            window.location.reload();

                        }, 300);

                    } else {

                        this.$message.error(data.message);

                    }
                    done();
                })
                .catch(_ => { });

        },
        async getProductListData(type) {

            this.productData = [];

            this.productLoad = true;

            let data = await getProductList({ brand: type });

            this.productLoad = false;

            if (data.code == 200) {

                this.productData = data.data;

                this.tabData = [{ value: 0, label: '全部商品' }, ...data.data1];

            } else {

                this.$message.error(data.message);

            }

        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-shop-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #f3f3f3;
}

.codics-aonaer-info-sys-user-shop-left-tab {
    height: 100%;
    width: 150px;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-shop-left-tab-item {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: center;
    cursor: pointer;
}

.codics-aonaer-info-sys-user-shop-right-box {
    height: fit-content;
    min-height: 517px;
    width: calc(100% - 150px);
    position: relative;
    float: left;
    box-sizing: border-box;
    background: #FFF;
    padding: 10px;
}

.codics-aonaer-info-sys-user-shop-right-box-empty {
    height: 130px;
    width: 130px;
    position: absolute !important;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
}

.codics-aonaer-info-sys-user-shop-right-box-empty img {
    user-select: none !important;
    -webkit-user-drag: none !important;
}

.codics-aonaer-info-sys-user-shop-right-box-load {
    height: 40px;
    width: 48px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 15% 15% 35% 35%;
    background: #CCC;
}

.codics-aonaer-info-sys-user-shop-right-box-load::after {
    content: "";
    position: absolute;
    left: 45px;
    top: 8px;
    border: 4px solid #CCC;
    width: 16px;
    height: 20px;
    border-radius: 0 4px 4px 0;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-shop-right-box-load::before {
    content: "";
    position: absolute;
    width: 1px;
    height: 10px;
    color: #CCC;
    top: -15px;
    left: 11px;
    -webkit-animation: animloader92 1s ease infinite;
    animation: animloader92 1s ease infinite;
}

@-webkit-keyframes animloader92 {
    0% {
        box-shadow: 2px 0px rgba(188, 188, 188, 0), 12px 0px rgba(188, 188, 188, 0.3), 20px 0px rgba(188, 188, 188, 0);
    }

    50% {
        box-shadow: 2px -5px rgba(188, 188, 188, 0.5), 12px -3px rgba(188, 188, 188, 0.5), 20px -2px rgba(188, 188, 188, 0.6);
    }

    100% {
        box-shadow: 2px -8px rgba(188, 188, 188, 0), 12px -5px rgba(188, 188, 188, 0), 20px -5px rgba(188, 188, 188, 0);
    }
}

@keyframes animloader92 {
    0% {
        box-shadow: 2px 0px rgba(188, 188, 188, 0), 12px 0px rgba(188, 188, 188, 0.3), 20px 0px rgba(188, 188, 188, 0);
    }

    50% {
        box-shadow: 2px -5px rgba(188, 188, 188, 0.5), 12px -3px rgba(188, 188, 188, 0.5), 20px -2px rgba(188, 188, 188, 0.6);
    }

    100% {
        box-shadow: 2px -8px rgba(188, 188, 188, 0), 12px -5px rgba(188, 188, 188, 0), 20px -5px rgba(188, 188, 188, 0);
    }
}

.codics-aonaer-info-sys-user-shop-right-box-product-item {
    height: fit-content;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    border: 1px solid #EEE;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
    transition: .3s;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-card:hover {
    transform: scale(1.05);
    box-shadow: 0 0 10px rgba(0, 0, 0, .3);
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-card-img {
    height: 230px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-title {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    box-sizing: border-box;
    padding: 0 10px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-line {
    height: 38px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 35px;
    font-size: 13px;
    font-weight: bold;
    box-sizing: border-box;
    padding: 0 10px;
    color: #ea5b18;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-exchange {
    height: 20px;
    width: fit-content;
    position: absolute;
    margin: auto;
    right: 10px;
    bottom: 10px;
    line-height: 19px;
    text-align: center;
    font-size: 10px;
    box-sizing: border-box;
    background: #FFF;
    border: 0.5px solid #ea5b18;
    color: #ea5b18;
    border-radius: 10px;
    padding: 0 10px;
    transition: .3s;
}

.codics-aonaer-info-sys-user-shop-right-box-product-item-exchange:hover {
    color: #FFF;
    background: #ea5b18;
}
</style>